import React, { useState,useEffect,useRef } from 'react';
import { Helmet } from 'react-helmet';
import './classes/SalespersonCreateApplication.css';
import SalespersonSidebar from './SalespersonSidebar';
import PhoneInput, {
  formatPhoneNumber,
  formatPhoneNumberIntl,
  isPossiblePhoneNumber,
  isValidPhoneNumber,getCountryCallingCode
} from 'react-phone-number-input'
import { configData } from "../config";
import Select from 'react-dropdown-select';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';

const SalespersonCreateApplication = ()  =>{
     const app_url = configData.APP_URL;
     const navigate = useNavigate();
     const initialForm = {
        FirstName:'',
        LastName: '',
        EMail: '',
        PrimaryPhone: '',
        SecondaryPhone: '',
        addressLine1: '',
        addressLine2: '',
        City: '',
        State: '',
        Region: '',
        Zip: '',
        Country: 'US',
        Linkedin: '',
        Sportsrecomm: '',
        Sportsreferrer: '',
        Referrername:'',
        Birthmonth: '',
        Birthdate: '',
        Birthyear: '',
        Gender: '',
        Educationlevel: '',
        University: '',
        MajorDegreeCourse: '',
        CurrentJob: '',
        militarymember: '',
        MilitaryId: '',
        convicted: '',
        convicted_explain: '',
        college_credit: '',
        favsportteam: '',
        appRegister_step: '1',
        about: '',
        pageURL: window.location.href, 
        salesperson:localStorage.getItem('drupal_uid'),
        showStateField: true,
        showProvinceField: false,
    };


const [formData, setFormData] = useState(initialForm);
const [errors, setErrors] = useState({});
 const [countriesList, setCountriesList] = useState([]);
  const [statelist, setStateList] = useState({});
  const [universityList, setUniversityList] = useState({});
  const [selectedcountry, setSelectedCountry] = useState([{ label: 'United States', value: 'US' }]);
const SportsrecommOptions = [
    "College Professor",
    "Dr. Lashbrook gave me his card",
    "Facebook",
    "Former Customer/Conference Attendee",
    "Google",
    "Instagram",
    "LinkedIn",
    "Podcast",
    "Radio Ad",
    "Received an SMWW newsletter email",
    "Referred by an SMWW Alumni",
    "Twitter",
    "YouTube"
]

const SportsreferrerOptions = [
    "Baseball America",
    "DegreesinSports.com",
    "Dr. Lashbrook gave me his business card!",
    "ESPN",
    "Fox Sports Radio",
    "Hockey News",
    "My professor",
    "NASSM",
    "NCAA News",
    "Other",
    "Racingjunk.com",
    "Rah Rah Rugby",
    "Search Engine",
    "Sherdog.com",
    "SLAM magazine",
    "SMWW Alumni told me about it",
    "SMWW Faculty",
    "WorkinSports.com"
]

const EducationlevelOptions = [
    "High School Diploma",
    "Some college",
    "Bachelor's Degree",
    "Master's Degree",
    "Doctoral Degree"
]
const formatResult = (item) => {
    return (
      <>
        
        <span style={{ display: 'block', textAlign: 'left' }}>{item.name}</span>
      </>
    )
  }

   const handleOnUniversitySelect = (item) => {
    // the item selected
     setFormData(prevState => ({
      ...prevState,
      University:item.name
    }));
  }
useEffect(() => {
    retrieveCountriesList();
    retrieveStateList();   
    retrieveUniversityList(); 
  }, []);
  async function retrieveStateList() {
    const statelistresponse = await fetch(
      app_url+'smwwstates/getstatelist',
      {
        method: "GET",

        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const statelistdata = await statelistresponse.json();
    
    const statelist = {};
    Object.keys(statelistdata.data.result).forEach(function(key) {
      
      statelist[key] = statelistdata.data.result[key];
    
    });
    setStateList(statelist);
   
  }
   async function retrieveUniversityList() {
    const universitylistresponse = await fetch(
      app_url+'application/getuniversity',
      {
        method: "GET",

        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const resonse = await universitylistresponse.json();
    if(resonse.data.msg == "Success") {
    setUniversityList(resonse.data.result);
    }
    
   
   
  }
  async function retrieveCountriesList() {
    const countrieslistresponse = await fetch(
      app_url+'smwwcountries/getcountrieslist',
      {
        method: "GET",

        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const countrieslistdata = await countrieslistresponse.json();

    setCountriesList(countrieslistdata.data.result);
   
    
    
  }
  const handleOpen = () => {
    setSelectedCountry([]);
    setFormData(prevState => ({
      ...prevState,
      country:''
    }));

  };
const handleChange = (e) => {
    const { name, value } = e.target;
    if(e.target.name === 'country') {
      if(e.target.value === 'US' || e.target.value === 'CA') {
        setFormData(prevState => ({
          ...prevState,
          showProvinceField: false,
          showStateField: true,
          province:'',
        }));

      } else {
        
        setFormData(prevState => ({
          ...prevState,
          showProvinceField: true,
          showStateField: false,
          State: '',
          Zip:''
        }));
       
      }
    
    } else {
        setFormData({ ...formData, [name]: value });
    }
    console.log(formData);
};
const isValidBasicPhone = (phone) => {
  const cleaned = phone.replace(/\D/g, ''); // Remove non-digit characters
  return cleaned.length >= 7 && cleaned.length <= 15;
};
const validate = (data) => {
  const newErrors = [];

  if (!data.FirstName.trim()) newErrors.push('First Name is required');
  if (!data.LastName.trim()) newErrors.push('Last Name is required');

  if (!data.EMail.trim()) {
    newErrors.push('Email is required');
  }  else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(?!\d+$)[a-zA-Z]{2,10}$/.test(data.EMail)) {

    newErrors.push('Invalid Email');
  }

 if (data.PrimaryPhone.trim()) {
  const digitsOnly = data.PrimaryPhone.replace(/\D/g, '');
  try {
    let codeLength = 0;
    if (formData.PrimaryPhoneCountry) {
      codeLength = getCountryCallingCode(formData.PrimaryPhoneCountry).length;
    } else {
      const match = digitsOnly.match(/^\d{1,3}/);
      if (match) codeLength = match[0].length;
    }

    if (digitsOnly.length > codeLength) {
      if (!isValidPhoneNumber(data.PrimaryPhone)) {
        newErrors.push('Invalid Primary Phone Number');
      }
    } else {
      // Only country code — treat as empty
      data.PrimaryPhone = '';
    }
  } catch {
    if (!isValidPhoneNumber(data.PrimaryPhone)) {
      newErrors.push('Invalid Primary Phone Number');
    }
  }
}

 
  if (data.Linkedin && !/^https?:\/\/(www\.)?linkedin\.com\/.*$/.test(data.Linkedin)) {
    newErrors.push('Invalid LinkedIn URL');
  }



if (data.SecondaryPhone) {
    if(data.SecondaryPhone.trim()) {
  if (!isValidBasicPhone(data.SecondaryPhone)) {
    newErrors.push('Invalid Secondary Phone Number');
  }
}
}
  return newErrors;
};

const handleCancel = async (e) => {
  e.preventDefault();
   const confirmed = window.confirm('Are you sure?');

    if (confirmed) {
      // User clicked "OK", proceed with the action
      navigate("/user/"+localStorage.getItem('drupal_uid'));
      
     window.scrollTo(0, 0);
      // Add your deletion logic here
    } else {
      // User clicked "Cancel"
      
    }
}
const handleSubmit = async (e) => {
  e.preventDefault();
    const formErrors = validate(formData);
  

  if (Object.keys(formErrors).length > 0) {
    setErrors(formErrors);
    window.scrollTo(0, 0);
  } else {
    setErrors({});
      const response = await fetch(app_url+'application/salespersoncreate', {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: {
        'Content-Type': 'application/json',
      },
      });
      const data = await response.json();
      if(data.data.result === "user_created") {
        navigate("/users/"+data.data.slug,{state:{userId: data.data.uid,message: 'Customer is created.'}});
        
      } else {
        setErrors(data.data.msg);
        window.scrollTo(0, 0);
      }
    

  }
};

    return(
        <div id="main" className="salespersonappn-main">   
        <Helmet>
            <title>Create customer</title>
        </Helmet>
          
            <> 
                  
                <div class=" left"></div>
                <div className=" center left-center">
                    <div className='salespersonappn-form-container' >
                        <div>
                            <h1>Create customer</h1>
                        </div>
                        <hr />
                        {errors.length > 0 && (
          <div className="set-message-error">
           {errors.map((item, index) => {
           return <>{item}<br /></>
          
        })}  
          </div>
        )}
                        <form onSubmit={handleSubmit}>
                            <div>
                                <fieldset style={{border:0}}>
                                    <legend>
                                        <span className="salespersonappn-legend">Contact Information</span>
                                    </legend>
                                    <div className="">
                                        <div className="salespersonappn-form-item">
                                            <label htmlFor="firstname">
                                                First Name <span className="form-required" title="This field is required.">*</span>
                                            </label>
                                            <input className='' type="text" id="firstname" name="FirstName"  value={formData.FirstName} onChange={handleChange} size="30" maxLength="50" />
                                        </div>
                                        <div className="salespersonappn-form-item">
                                            <label htmlFor="lastname">
                                                Last Name <span className="form-required" title="This field is required.">*</span>
                                            </label>
                                            <input className='' type="text" id="lastname" name="LastName" value={formData.LastName} onChange={handleChange} size="30" maxLength="50" />
                                        </div>
                                        <div className="salespersonappn-form-item">
                                            <label htmlFor="eMail">
                                                Email <span className="form-required" title="This field is required.">*</span>
                                            </label>
                                            <input className="salespersonappn-form-input" type="text" id="eMail" name="EMail" value={formData.EMail} onChange={handleChange} maxLength="255" />
                                        </div>
                                        <div className="salespersonappn-form-item">
                                            <label htmlFor="cell_phone">
                                                Primary Phone
                                            </label>
                                            <PhoneInput
                                              international
                                              countryCallingCodeEditable={false}
                                              placeholder="Enter phone number"
                                              className="smww-appn"
                                              value={formData.PrimaryPhone}
                                              defaultCountry={formData.PrimaryPhoneCountry || 'US'}
                                              onCountryChange={(country) => {
                                                setFormData((prev) => ({
                                                  ...prev,
                                                  PrimaryPhoneCountry: country,
                                                }));
                                              }}
                                            onChange={(phone) => {

                                              if (!phone) {
                                                console.log('Phone input cleared.');
                                                setFormData((prev) => ({
                                                  ...prev,
                                                  PrimaryPhone: '',
                                                }));
                                                return;
                                              }

                                              const digitsOnly = phone.replace(/\D/g, '');

                                              let codeLength = 0;

                                              if (formData.PrimaryPhoneCountry) {
                                                codeLength = getCountryCallingCode(formData.PrimaryPhoneCountry).length;
                                              } else {
                                                const match = digitsOnly.match(/^\d{1,3}/);
                                                if (match) {
                                                  codeLength = match[0].length;
                                                }
                                              }

                                              if (digitsOnly.length <= codeLength) {
                                                setFormData((prev) => ({
                                                  ...prev,
                                                  PrimaryPhone: '',
                                                }));
                                              } else {
                                                setFormData((prev) => ({
                                                  ...prev,
                                                  PrimaryPhone: phone,
                                                }));
                                              }
                                            }}

                                            />

                                        </div>    
                                        <div className="salespersonappn-form-item">
                                            <label htmlFor="mobile_phone">
                                                Secondary Phone
                                            </label>
                                            <input className='' type="text" id="mobile_phone" name="SecondaryPhone" value={formData.SecondaryPhone} onChange={handleChange} size="30" maxLength="20" />
                                        </div>   
                                        <div className="salespersonappn-form-item">
                                            <label htmlFor="address_line1">
                                                Street Address
                                            </label>
                                            <input className="" type="text" id="address_line1" name="addressLine1"  value={formData.addressLine1} onChange={handleChange} size="30" maxLength="255" />
                                        </div>
                                        <div className="salespersonappn-form-item">
                                            <label htmlFor="address_line2">
                                                Address (cont.) 
                                            </label>
                                            <input className="" type="text" id="address_line2" name="addressLine2"  value={formData.addressLine2} onChange={handleChange}  size="30" maxlength="255" />
                                        </div>
                                        <div className="salespersonappn-form-item">
                                            <label htmlFor="appn_city">
                                                City/Town
                                            </label>
                                            <input className="" type="text" id="appn_city" name="City" value={formData.City} onChange={handleChange} size="30" maxlength="50" />
                                        </div>  
                                        {formData.showStateField &&
                                        <><div className="salespersonappn-form-item">
                                            <label htmlFor="appn_state">
                                                State:
                                            </label>
                                            <select className='' id="state" name="State"   onChange={handleChange} >
                                                <option value="">Select a State or Province</option>
                                                <option value="-">Outside the US or Canada</option>
                                                    {Object.keys(statelist).map(state => {
                                                        return <option key={statelist[state].name} value={statelist[state].name}>{statelist[state].name}</option>
                                                     })}
                                            </select>
                                        </div>  
                                        <div className="salespersonappn-form-item">
                                            <label htmlFor="appn_zip">
                                                Zip/Postal Code:
                                            </label>
                                            <input className="" type="text" id="appn_zip" name="Zip"   value={formData.Zip} onChange={handleChange}  size="30" maxlength="20" />
                                        </div>  </> 
                                        }
                                        {formData.showProvinceField &&
                                        <div className="salespersonappn-form-item">
                                            <label htmlFor="appn_region">
                                                Province/Region
                                            </label>
                                            <input className="" type="text" id="appn_region" name="Region"  value={formData.Region} onChange={handleChange}  size="30" maxlength="100" />
                                        </div>   
                                        }
                                        
                                        <div className="salespersonappn-form-item">
                                            <label htmlFor="appn_country">
                                                Country
                                            </label>
                                           <Select 
                                            id="Country" name="Country" className='select-country smww-appn'
                                            searchable={true}
                                            required={true}  
                                            clearable={true} 
                                            clearOnBlur={true} 
                                            clearOnSelect={true}
                                            backspaceDelete={true} 
                             
                                            style={{backgroundColor:'#ffffff', width:'87.8%', borderRadius: 5}}
                                                
                                            options={countriesList} 
                             
                                            onChange={(val) => {
                                            if(val.length == 0) {
                                                console.log(val);
                                            }
                                            else{
                                                setSelectedCountry(val);
                                                setFormData({ ...formData, 'Country': val[0]['value'] });
                                                handleChange(
                                                { target: { value: val[0]['value'], name: 'country' } }
                                                )
                               
                                            }}
                                            }
                                        onDropdownOpen={handleOpen}
                                            values={selectedcountry} 
                             
                                        />
                                        </div>  
                                        <div className="salespersonappn-form-item">
                                            <label htmlFor="appn_linkedin">
                                                Your LinkedIn URL
                                            </label>
                                            <input className="salespersonappn-form-input" type="text" id="appn_linkedin" name="Linkedin" value={formData.Linkedin} onChange={handleChange} maxlength="600" />
                                        </div>                                 
                                    </div>
                                </fieldset>
                                <fieldset style={{border:0}}>
                                    <legend>
                                        <span className="salespersonappn-legend">To help us evaluate your application, please answer the following questions:</span>
                                    </legend>
                                    <div>
                                        <div className="salespersonappn-form-item">
                                            <label htmlFor="appn_sportsrecomm">
                                                How did you hear about us?
                                            </label>
                                            <select
                                                className=''
                                                name="Sportsrecomm"
                                                value={formData.Sportsrecomm}
                                                onChange={handleChange} >
                                                <option value="">Select</option>
                                                {SportsrecommOptions.map((option, index) => (
                                                <option key={index} value={option}>
                                                    {option}
                                                </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="salespersonappn-form-item">
                                            <label htmlFor="appn_sportsreferrer">
                                                Referrer
                                            </label>
                                            <select
                                                className=''
                                                name="Sportsreferrer"
                                                value={formData.Sportsreferrer}
                                                onChange={handleChange} >
                                                <option value="">How did you hear about us?</option>
                                                {SportsreferrerOptions.map((option, index) => (
                                                <option key={index} value={option}>
                                                    {option}
                                                </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="salespersonappn-form-item">
                                            <label htmlFor="appn_referrername">
                                                Name of person who referred you:
                                            </label>
                                            <input className="salespersonappn-form-input" type="text" id="appn_referrername" name="Referrername"  value={formData.Referrername} onChange={handleChange} maxlength="128" />
                                        </div> 
                                        
                                        <div className="salespersonappn-form-item">
                                        <label>What is your birthday?</label>

                                        {/* Month */}
                                        <div className="salespersonappn-bday-col">
                                            <div className="salespersonappn-form-item">
                                            <select
                                                id="appn_bmonth"
                                                name="Birthmonth"
                                                value={formData.Birthmonth}
                                                onChange={handleChange}
                                            >
                                            
                                                {["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"].map((month, i) => (
                                                   
                                                <option key={i+1} value={i+1}>{month}</option>
                                                ))}
                                            </select>
                                            </div>
                                        </div>

                                        {/* Day */}
                                        <div className="salespersonappn-bday-col">
                                            <div className="salespersonappn-form-item">
                                            <select
                                                id="appn_bdate"
                                                name="Birthdate"
                                                value={formData.Birthdate}
                                                onChange={handleChange}
                                            >
                                                
                                                {Array.from({ length: 31 }, (_, i) => {
                                                const day = (i + 1).toString().padStart(2, '0');
                                                return <option key={day} value={day}>{day}</option>;
                                                })}
                                            </select>
                                            </div>
                                        </div>

                                        {/* Year */}
                                        <div className="salespersonappn-bday-col">
                                            <div className="salespersonappn-form-item">
                                            <select
                                                id="appn_byear"
                                                name="Birthyear"
                                                value={formData.Birthyear}
                                                onChange={handleChange}
                                            >
                                            
                                                {Array.from({ length: new Date().getFullYear() - 1950 + 1 }, (_, i) => {
                                                const year = new Date().getFullYear() - i;
                                                return <option key={year} value={year}>{year}</option>;
                                                })}
                                            </select>
                                            </div>
                                        </div>

                                        <div className="salespersonappn-clear"></div>
                                        </div>


                            <div className="salespersonappn-form-item">
                            <label htmlFor="appn_gender">Gender</label>
                            <div>
                                <div className="appn-form-radios">
                                <input
                                    className="appn-form-radio"
                                    name="Gender"
                                    type="radio"
                                    id="appn_gender_male"
                                    value="Male"
                                    checked={formData.Gender === "Male"}
                                    onChange={handleChange}
                                />
                                <label htmlFor="appn_gender_male">Male</label>
                                </div>
                                <div className="appn-form-radios">
                                <input
                                    className="appn-form-radio"
                                    name="Gender"
                                    type="radio"
                                    id="appn_gender_female"
                                    value="Female"
                                    checked={formData.Gender === "Female"}
                                    onChange={handleChange}
                                />
                                <label htmlFor="appn_gender_female">Female</label>
                                </div>
                                <div className="appn-form-radios">
                                <input
                                    className="appn-form-radio"
                                    name="Gender"
                                    type="radio"
                                    id="appn_gender_nonbinary"
                                    value="Non-binary"
                                    checked={formData.Gender === "Non-binary"}
                                    onChange={handleChange}
                                />
                                <label htmlFor="appn_gender_nonbinary">Non-binary</label>
                                </div>
                                <div className="appn-form-radios">
                                <input
                                    className="appn-form-radio"
                                    name="Gender"
                                    type="radio"
                                    id="appn_gender_prefernot"
                                    value="Prefer not to answer"
                                    checked={formData.Gender === "Prefer not to answer"}
                                    onChange={handleChange}
                                />
                                <label htmlFor="appn_gender_prefernot">Prefer not to answer</label>
                                </div>
                            </div>
                            </div>
 
                                        <div className="salespersonappn-form-item">
                                            <label htmlFor="appn_educationlevel">
                                                Education Level Completed
                                            </label>
                                            <select
                                                className=''
                                                name="Educationlevel"
                                                value={formData.Educationlevel}
                                                onChange={handleChange} >
                                                <option value="">- Select -</option>
                                                {EducationlevelOptions.map((option, index) => (
                                                <option key={index} value={option}>
                                                    {option}
                                                </option>
                                                ))}
                                            </select>
                                        </div> 
                                        <div className="salespersonappn-form-item">
                                            <label htmlFor="appn_university">
                                                University
                                            </label>
                                           <ReactSearchAutocomplete className="university"
                                                       items={universityList}
                                                       
                                                       onSelect={handleOnUniversitySelect}
                                                      formatResult={formatResult} 
                                                      showIcon={false}
                                                       
                                                       
                                                     />
                                        </div> 
                                         <div className="salespersonappn-form-item">
                                            <label htmlFor="appn_degree">
                                             Major / Degree / Course Completed 
                                            </label>
                                            <input className="degree-input salespersonappn-form-input" type="text" id="appn_degree" name="MajorDegreeCourse" value={formData.MajorDegreeCourse} onChange={handleChange} maxlength="128" />
                                        </div> 
                                         <div className="salespersonappn-form-item">
                                            <label htmlFor="appn_currentjob">
                                                 Current Job 
                                            </label>
                                            <input className="currentjob-input salespersonappn-form-input" type="text" id="appn_currentjob" name="CurrentJob" value={formData.CurrentJob} onChange={handleChange} maxlength="128" />
                                        </div> 
                                         <div className="salespersonappn-form-item">
                                            <label htmlFor="appn_militarymember">Are You a Member of the Military?</label>
                                            <div>
                                                <div className="appn-form-radios">
                                                <input
                                                    className="appn-form-radio"
                                                    name="militarymember"
                                                    type="radio"
                                                    id="appn_militarymember_yes"
                                                    value="Yes"
                                                    checked={formData.militarymember === "Yes"}
                                                    onChange={handleChange}
                                                />
                                                <label htmlFor="appn_militarymember_yes">Yes</label>
                                                </div>
                                                <div className="appn-form-radios">
                                                <input
                                                    className="appn-form-radio"
                                                    name="militarymember"
                                                    type="radio"
                                                    id="appn_militarymember_no"
                                                    value="No"
                                                    checked={formData.militarymember === "No"}
                                                    onChange={handleChange}
                                                />
                                                <label htmlFor="appn_militarymember_no">No</label>
                                                </div>
                                            </div>
                                            </div>

                                         <div className="salespersonappn-form-item">
                                            <label htmlFor="appn_militaryid">
                                                 If Yes, please provide your military ID number 
                                            </label>
                                            <input className="militaryid-input salespersonappn-form-input" type="text" id="appn_militaryid" name="MilitaryId" value={formData.MilitaryId} onChange={handleChange} maxlength="128" />
                                            <div className="description">(We provide a Military Discount for those who have served) </div>
                                        </div>
                                       <div className="salespersonappn-form-item">
                                        <label htmlFor="appn_convicted">Have you ever been convicted of a felony?</label>
                                        <div>
                                            <div className="appn-form-radios">
                                            <input
                                                className="appn-form-radio"
                                                name="convicted"
                                                type="radio"
                                                id="appn_convicted_yes"
                                                value="Yes"
                                                checked={formData.convicted === "Yes"}
                                                onChange={handleChange}
                                            />
                                            <label htmlFor="appn_convicted_yes">Yes</label>
                                            </div>
                                            <div className="appn-form-radios">
                                            <input
                                                className="appn-form-radio"
                                                name="convicted"
                                                type="radio"
                                                id="appn_convicted_no"
                                                value="No"
                                                checked={formData.convicted === "No"}
                                                onChange={handleChange}
                                            />
                                            <label htmlFor="appn_convicted_no">No</label>
                                            </div>
                                        </div>
                                        </div>

                                         <div className="salespersonappn-form-item">
                                            <label htmlFor="appn_convictedExplain">
                                                If yes, please explain: 
                                            </label>
                                            <input className="convictedExplain-input salespersonappn-form-input" type="text" id="appn_convictedExplain" name="convicted_explain" value={formData.convicted_explain} onChange={handleChange} maxlength="128" />                                           
                                        </div>
                                         <div className="salespersonappn-form-item">
                                            <label htmlFor="appn_collegecredit">Do you plan to take this course toward college credit?</label>
                                            <div>
                                                <div className="appn-form-radios">
                                                <input
                                                    className="appn-form-radio"
                                                    name="college_credit"
                                                    type="radio"
                                                    id="appn_collegecredit_yes"
                                                    value="Yes"
                                                    checked={formData.college_credit === "Yes"}
                                                    onChange={handleChange}
                                                />
                                                <label htmlFor="appn_collegecredit_yes">Yes</label>
                                                </div>
                                                <div className="appn-form-radios">
                                                <input
                                                    className="appn-form-radio"
                                                    name="college_credit"
                                                    type="radio"
                                                    id="appn_collegecredit_no"
                                                    value="No"
                                                    checked={formData.college_credit === "No"}
                                                    onChange={handleChange}
                                                />
                                                <label htmlFor="appn_collegecredit_no">No</label>
                                                </div>
                                            </div>
                                            </div>

                                         <div className="salespersonappn-form-item">
                                            <label htmlFor="appn_favsportteam">
                                                If you could work for your favorite sports team, who would it be?  
                                            </label>
                                            <input className="favsportteam-input salespersonappn-form-input" type="text" id="appn_favsportteam" name="favsportteam"  value={formData.favsportteam} onChange={handleChange} maxlength="128" />                                           
                                        </div>
                                         <div className="salespersonappn-form-item">
                                            <label htmlFor="reg_step">App Register Step</label>
                                            <select
                                                id="appRegister_step"
                                                name="appRegister_step"
                                                className="adduser-register-select"
                                                value={formData.appRegister_step}
                                                onChange={handleChange}
                                                >
                                                <option value="_none">- None -</option>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                            </select>
                                        </div>
                                        <div className="salespersonappn-form-item">
                                            <label htmlFor="about">Tell Us Your Story: </label>
                                            <textarea
                                                    id="about"
                                                    cols="50"
                                                    rows="7"
                                                    name="about"
                                                   value={formData.about} 
                                                   onChange={handleChange}
                                                />
                                            <div className="grippie" style={{ background: `#eee url("/images/grippie.png") no-repeat center 2px` }}></div>
                                             <div className="description">To help us understand you as an individual and not just an applicant, please tell us about why you are interested in taking this course.</div>
                                        </div>
                                        <div className="salespersonappn-form-actions">
                                            <input type="submit" value="Submit" className="salespersonappn-form-submit form-submit"  />
                                            <input type="submit" value="Cancel" className="salespersonappn-form-cancel" onClick={handleCancel} 
                                            style={{ background: `#999 url("/images/overlay.png") repeat-x` }} 
                                            />
                                        </div>
                        
                                    </div>
                                </fieldset>
                            </div>
                        </form>
                    </div>
                </div>
    
            </>
            <div class="right">
                <SalespersonSidebar/>
            </div>
            <div className='clear'></div>
        </div>
    );
};

export default SalespersonCreateApplication;